import * as React from 'react';
import {TextInput} from "./TextInput";

export class EmailInput extends TextInput {
    protected type:string = 'email';
}